import {
  CreateStudyDto,
  CreateSubjectOrderDto,
  IRequestConfig,
  IRequestOptions,
  ShApiResponse_Boolean,
  ShApiResponse_GetOrganizationStudiesDto,
  ShApiResponse_GetStudyDto,
  ShApiResponse_GetSubjectDto,
  ShApiResponse_GetSubjectOrderDto,
  ShApiResponse_List_GetStudyDto,
  UpdateStudyDto,
  UpdateStudyUserDto,
  axios,
  basePath,
  getConfigs,
} from "./index.defs";

export class StudiesApiService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   * Returns a list of all the studies under the user's organization with counters for users and subjects
   */
  static studiesGetOrganizationStudies(
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetOrganizationStudiesDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/v2/studies";

      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Returns a list of all the studies under the user's organization
   */
  static studiesGetStudies(
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_List_GetStudyDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/studies";

      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Creates a new study
   */
  static studiesCreateStudy(
    params: {
      /**  */
      studyDto: CreateStudyDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetStudyDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/studies";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["studyDto"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Returns the study with the given id
   */
  static studiesGetStudy(
    params: {
      /**  */
      id: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetStudyDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/studies/{id}";
      url = url.replace("{id}", params["id"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Deletes a study from the system. Only allowed if no users and no ECGs are linked to it
   */
  static studiesDeleteStudy(
    params: {
      /**  */
      id: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/studies/{id}";
      url = url.replace("{id}", params["id"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "delete",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Updates a study
   */
  static studiesUpdateStudy(
    params: {
      /**  */
      id: string;
      /**  */
      studyDto: UpdateStudyDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetStudyDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/studies/{id}";
      url = url.replace("{id}", params["id"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "patch",
        "application/json",
        url,
        options
      );

      let data = params["studyDto"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Creates a new order for subject
   */
  static studiesCreateSubjectOrder(
    params: {
      /**  */
      id: string;
      /**  */
      order: CreateSubjectOrderDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetSubjectOrderDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/studies/{id}/orders";
      url = url.replace("{id}", params["id"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["order"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Updates a multiple user-study links
   */
  static studiesUpdateUsers(
    params: {
      /**  */
      id: string;
      /**  */
      users: UpdateStudyUserDto[];
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetStudyDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/studies/{id}/users";
      url = url.replace("{id}", params["id"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "patch",
        "application/json",
        url,
        options
      );

      let data = params["users"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get information about the given subject
   */
  static studiesGetStudySubject(
    params: {
      /**  */
      studyId: string;
      /**  */
      subjectId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetSubjectDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/studies/{studyId}/subjects/{subjectId}";
      url = url.replace("{studyId}", params["studyId"] + "");
      url = url.replace("{subjectId}", params["subjectId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
